import type { NodeSerializerSpec } from "@ext/markdown/core/edit/logic/Prosemirror/to_markdown";

// A block holding only an empty paragraph is written empty: the reader fills an empty block with one.
const paragraphFormatter: NodeSerializerSpec = async (state, node, parent) => {
	if (node.content?.size) await state.renderInline(node);
	else if (parent.childCount === 1) return;
	else state.write("\n");
	state.closeBlock(node);
};

export default paragraphFormatter;
